import { render, staticRenderFns } from "./RabotaruTokenExpiredBar.vue?vue&type=template&id=45db01cb&scoped=true&"
import script from "./RabotaruTokenExpiredBar.vue?vue&type=script&lang=js&"
export * from "./RabotaruTokenExpiredBar.vue?vue&type=script&lang=js&"
import style0 from "./RabotaruTokenExpiredBar.vue?vue&type=style&index=0&id=45db01cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db01cb",
  null
  
)

/* custom blocks */
import block0 from "./RabotaruTokenExpiredBar.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./RabotaruTokenExpiredBar.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
